import React from 'react';
import { CheckCircle, Clock, AlertCircle, ShieldCheck } from 'lucide-react';

const TaskStatusBadge = ({ status, integrationSource }) => {
  const isAutoVerified = status === 'auto_verified';
  const isManualVerified = status === 'manually_verified';
  const isPending = status === 'pending';
  const isFailed = status === 'failed';

  // Source display names
  const sourceNames = {
    aws: 'AWS',
    google_workspace: 'Google Workspace',
    github: 'GitHub',
  };

  if (isAutoVerified) {
    return (
      <div className="flex items-center gap-1.5 px-2 py-1 bg-green-50 border border-green-200 rounded text-xs">
        <CheckCircle className="w-3.5 h-3.5 text-green-600" />
        <span className="font-medium text-green-700">
          Verified via {sourceNames[integrationSource] || integrationSource}
        </span>
      </div>
    );
  }

  if (isManualVerified) {
    return (
      <div className="flex items-center gap-1.5 px-2 py-1 bg-blue-50 border border-blue-200 rounded text-xs">
        <ShieldCheck className="w-3.5 h-3.5 text-blue-600" />
        <span className="font-medium text-blue-700">Manually Verified</span>
      </div>
    );
  }

  if (isFailed) {
    return (
      <div className="flex items-center gap-1.5 px-2 py-1 bg-red-50 border border-red-200 rounded text-xs">
        <AlertCircle className="w-3.5 h-3.5 text-red-600" />
        <span className="font-medium text-red-700">Failed</span>
      </div>
    );
  }

  // Pending
  return (
    <div className="flex items-center gap-1.5 px-2 py-1 bg-amber-50 border border-amber-200 rounded text-xs">
      <Clock className="w-3.5 h-3.5 text-amber-600" />
      <span className="font-medium text-amber-700">Pending</span>
    </div>
  );
};

export default TaskStatusBadge;
